import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser'

import UserStore from 'stores/UserStore'
import INFRA_USERS_IDS from 'utils/testUsers'

import { CUSTOMERIO_EVENT_NAMES, CUSTOMERIO_WRITE_KEY } from './customerio-tracker.consts'
import type { CustomerioIdentifyProps, CustomerioTracker } from './customerio-tracker.types'

const customerio = new AnalyticsBrowser()

const shouldTrack = (userId: string) => {
  const isInfraUser = INFRA_USERS_IDS.includes(userId)
  const isImpersonating = UserStore.isImpersonating

  return !isInfraUser && !isImpersonating && !!CUSTOMERIO_WRITE_KEY
}

export const customerioTracker: CustomerioTracker = {
  eventNames: CUSTOMERIO_EVENT_NAMES,

  init: () => {
    if (CUSTOMERIO_WRITE_KEY) {
      customerio.load({ writeKey: CUSTOMERIO_WRITE_KEY })
    }
  },

  identify: ({ userId, traits }: CustomerioIdentifyProps) => {
    if (shouldTrack(userId)) {
      customerio.identify(userId, traits)
    }
  },
  track: async (event, properties) => {
    const currentUser = await customerio.user()
    const userId = currentUser?.id()

    if (userId && shouldTrack(userId)) {
      customerio.track(event, properties)
    }
  },
}
